import React from 'react'
import Inventory from './create/Inventory'
import Category from './create/Category'
import ProductInfo from './create/ProductInfo'
import Seo from './create/Seo'
import Brand from './create/Brand'
import Highlights from './create/Highlights'
import Tax from './create/Tax'
import FreeGift from './create/FreeGift'
import { useSelector } from 'react-redux'

const Detail = ({
  productId,
  isEditMode,
  setBrandName,
  dataChangeHandler,
  setBrandData,
  brandData,
  groupId,
  setGroupId,
  sku,
  setName,
  setSKU,
  seo,
  handleInputChange,
  name,
  slug,
  description,
  price,
  wasPrice,
  quantity,
  hsn,
  weight,
  length,
  breadth,
  height,
  setSlug,
  setPrice,
  setWasPrice,
  setDescription,
  setQuantity,
  setHsn,
  setWeight,
  setLength,
  setBreadth,
  setHeight,
  setIsActive,
  uploadFileHandler,
  media,
  setMedia,
  isActive,
  highlights,
  setHighlights,
  pId,
  optionsDataNew,
  setOptionsDataNew,
  handleTaxChange,
  tax,
  freeGiftEnabled,
  setFreeGiftEnabled,
  freeGiftProductId,
  setFreeGiftProductId,
  freeGiftQty,
  setFreeGiftQty,
  freeGiftQtyMode,
  setFreeGiftQtyMode,
  freeGifts,
  setFreeGifts,
  warrantyTitle,
  setWarrantyTitle,
  warrantyDescription,
  setWarrantyDescription,
}) => {
  const { userInfo } = useSelector((state) => state.userLogin) || {}

  const authHeaders = userInfo?.token
    ? { Authorization: `Bearer ${userInfo.token}` }
    : {}

  return (
    <section className='product-admin'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-8'>

            <ProductInfo
              dataChangeHandler={dataChangeHandler}
              setName={setName}
              setSlug={setSlug}
              setDescription={setDescription}
              name={name}
              slug={slug}
              description={description}
              setGroupId={setGroupId}
              groupId={groupId}
              isEditMode={isEditMode}
              productId={productId}
            />

            <FreeGift
              enabled={freeGiftEnabled}
              setEnabled={setFreeGiftEnabled}
              giftProductId={freeGiftProductId}
              setGiftProductId={setFreeGiftProductId}
              giftQty={freeGiftQty}
              setGiftQty={setFreeGiftQty}
              giftQtyMode={freeGiftQtyMode}
              setGiftQtyMode={setFreeGiftQtyMode}
              freeGifts={freeGifts}
              setFreeGifts={setFreeGifts}
              currentProductId={productId}
              dataChangeHandler={dataChangeHandler}
            />

            <Inventory
              setSKU={setSKU}
              setQuantity={setQuantity}
              sku={sku}
              quantity={quantity}
              hsn={hsn}
              setHsn={setHsn}
              weight={weight}
              setWeight={setWeight}
              length={length}
              setLength={setLength}
              breadth={breadth}
              setBreadth={setBreadth}
              height={height}
              setHeight={setHeight}
            />

            <Seo handleInputChange={handleInputChange} seo={seo} />

            <Tax handleTaxChange={handleTaxChange} tax={tax} />

            <div className='card mb-3'>
              <div className='card-header'>
                <label className='form-label'>Warranty</label>
              </div>
              <div className='card-body'>
                <label className='form-label'>Title</label>
                <input
                  type='text'
                  className='form-control mb-3'
                  placeholder='e.g. 1 Year Warranty'
                  value={warrantyTitle || ''}
                  onChange={(e) => setWarrantyTitle(e.target.value)}
                />
                <label className='form-label'>Description</label>
                <textarea
                  className='form-control'
                  rows='2'
                  placeholder='e.g. Provided by the manufacturer from date of purchase'
                  value={warrantyDescription || ''}
                  onChange={(e) => setWarrantyDescription(e.target.value)}
                />
              </div>
            </div>

            <Highlights
              productId={productId}
              value={highlights}
              onChange={setHighlights}
              headers={authHeaders}
              onSaved={(resp) => console.log('Saved:', resp)}
              onError={(err) => console.error(err)}
            />
          </div>

          <div className='col-lg-4'>
            <div className='card mb-3'>
              <div className='card-header'>
                <label className='form-label'>Product Status</label>
              </div>
              <div className='card-body'>
                <select
                  className='form-select'
                  name='isActive'
                  value={isActive ? 'true' : 'false'}           // ✅ controlled
                  onChange={(e) => setIsActive(e.target.value === 'true')} // ✅ boolean
                >
                  <option value='true'>Active</option>
                  <option value='false'>Inactive</option>
                </select>
              </div>
            </div>

            <div className='card'>
              <div className='card-header'>
                <label className='form-label'>Product</label>
              </div>
              <div className='card-body'>
                <Brand
                  setBrandData={setBrandData}
                  brandData={brandData}
                  setBrandName={setBrandName}
                />
                <Category productId={productId} />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}

export default Detail
